// import React from "react";
// import {
//   IconArrowLeft,
//   IconPrinter,
//   IconFileText,
//   IconTrash,
//   IconLayoutGrid,
//   IconSearch,
//   IconChevronDown,
//   IconRotate2,
// } from "@tabler/icons-react";
// import { IoArrowUndoCircle, IoArrowUndoCircleOutline } from "react-icons/io5";
// import { usePicklistByIdQuery } from "../../../apis/picklistApis";
// import formatDate from "../../../utilities/helper";
// import TableSkeleton from "../../../components/skeleton/TableSkeleton";
// import NoDataFound from "../../../components/common/NoDataFound";

// interface PickingDetailsProps {
//   onBack: () => void;
//   picklistId: string;
// }

// interface PickingDetailRow {
//   sn: number;
//   awb: string;
//   ref: string;
//   warehouse: string;
//   origin: string;
//   country: string;
//   city: string;
//   district: string;
//   receiverName: string;
//   receiverMobile: string;
//   receiverAddress: string;
//   items: {
//     sku: string;
//     qty: number;
//     status: string;
//     color: string;
//   }[];
//   trackNo: string;
//   orderType: string;
//   amount: string;
//   picker: string;
//   pickupDate: string;
//   pickupStatus: string;
//   client: string;
//   tplCompany: string;
//   tplAwb: string;
//   createdBy: string;
//   createdAt: string;
// }

// const PickingDetails: React.FC<PickingDetailsProps> = ({
//   onBack,
//   picklistId,
// }) => {
//   const {
//     data: picklist,
//     isLoading,
//     isError,
//   } = usePicklistByIdQuery(picklistId);

//   if (isLoading) {
//     return (
//       <div className="p-8">
//         <TableSkeleton
//           columns={[
//             "#",
//             "AWB",
//             "Ref",
//             "Warehouse",
//             "Origin",
//             "Receiver",
//             "SKU",
//             "Status",
//           ]}
//         />
//       </div>
//     );
//   }

//   if (isError || !picklist) {
//     return (
//       <div className="flex flex-col h-full items-center justify-center bg-[#F7F6F2]">
//         <NoDataFound message="Failed to load picklist details" />
//         <button
//           onClick={onBack}
//           className="mt-4 px-6 py-2 bg-[#FCB910] rounded-full font-bold"
//         >
//           Go Back
//         </button>
//       </div>
//     );
//   }

//   // Map API data to the table structure
//   const details: PickingDetailRow[] =
//     picklist.picklistOrders?.map((po: any, idx: number) => {
//       const order = po.order;
//       const senderAddr = order?.sender?.addresses?.[0];
//       const receiverAddr = order?.receiver?.addresses?.[0];
//       console.log("Sender Address: ", senderAddr);
//       // Map items from orderAllocations if available, otherwise from oLineItems
//       const items =
//         po.orderAllocations?.length > 0
//           ? po.orderAllocations.map((alloc: any) => ({
//               sku: alloc.product?.sku || "",
//               qty: alloc.quantity || 0,
//               status: alloc.status || "",
//               color: "bg-blue-500",
//               // location: alloc.whBinLocation?.binNumber || alloc.whPalletLocation?.palletNumber || ""
//               location:
//                 alloc.whBinLocation?.barcodeLabel ||
//                 alloc.whPalletLocation?.barcodeLabel ||
//                 "",
//             }))
//           : order?.oLineItems?.map((item: any) => ({
//               sku: item.sku || "",
//               qty: item.quantity || 0,
//               status: item.status || "",
//               color: "bg-gray-300",
//               location: "",
//             })) || [
//               {
//                 sku: "",
//                 qty: 0,
//                 status: "",
//                 color: "bg-gray-300",
//                 location: "",
//               },
//             ];

//       return {
//         sn: idx + 1,
//         awb: order?.awbNumber || "",
//         ref: order?.referenceNumber || "",
//         warehouse: order?.warehouse?.name || picklist.warehouseId || "",
//         origin: senderAddr?.cityName || "",
//         country: receiverAddr?.countryName || "",
//         city: receiverAddr?.cityName || "",
//         district: receiverAddr?.districtName || "",
//         receiverName: order?.receiver?.name || "",
//         receiverMobile: order?.receiver?.mobile || "",
//         receiverAddress: receiverAddr?.address?.replace(/<[^>]*>/g, "") || "",
//         items,
//         trackNo: order?.awbNumber || "",
//         orderType: order?.shipment?.paymentType || "",
//         amount: order?.shipment?.codAmount
//           ? `SAR ${order.shipment.codAmount}`
//           : "SAR 0.00",
//         picker:
//           picklist.assignee?.details?.fullName ||
//           picklist.assignee?.email ||
//           "",
//         pickupDate: formatDate(picklist.createdAt),
//         pickupStatus:
//           order?.status === "PICKED" || order?.status === "PICKED_UP"
//             ? "YES"
//             : "NO",
//         client: picklist.client?.name || "",
//         tplCompany: "",
//         tplAwb: "",
//         createdBy:
//           picklist.creator?.details?.fullName || picklist.creator?.email || "",
//         createdAt: formatDate(picklist.createdAt),
//       };
//     }) || [];

//   return (
//     // <div className="flex flex-col h-full bg-[#F7F6F2]">
//     //   <div className="flex items-center justify-between px-6 py-4 bg-transparent">
//     //     <div className="flex items-center gap-4">
//     //       <button
//     //         onClick={onBack}
//     //         className="p-2 hover:bg-white/50 rounded-full transition-colors"
//     //       >
//     //         <IconArrowLeft size={20} />
//     //       </button>
//     //       <h1 className="text-xl font-bold text-[#212121]">View detail</h1>
//     //     </div>
//     //     <div className="flex items-center gap-3">
//     //       <button className="p-2 bg-white rounded-full shadow-sm hover:shadow-md transition-all text-gray-600">
//     //         <IconFileText size={20} />
//     //       </button>
//     //       <button className="p-2 bg-white rounded-full shadow-sm hover:shadow-md transition-all text-gray-600">
//     //         <IconPrinter size={20} />
//     //       </button>
//     //       <button className="p-2 bg-white rounded-full shadow-sm hover:shadow-md transition-all text-red-500">
//     //         <IconTrash size={20} />
//     //       </button>
//     //       <button className="p-2 bg-[#FCB910] rounded-full shadow-lg text-[#212121]">
//     //         <IconLayoutGrid size={20} />
//     //       </button>
//     //     </div>
//     //   </div>

//     //   <div className="mx-6 bg-white rounded-[32px] overflow-hidden shadow-xl flex flex-col h-full mb-6">
//     //     <div className="flex items-center justify-between px-8 py-6 border-b border-gray-100">
//     //       <h2 className="text-2xl font-black text-[#212121] tracking-tight">
//     //         {picklist.picklistNumber}
//     //       </h2>

//     //       <div className="flex items-center gap-4">
//     //         <div className="flex items-center bg-[#F7F6F2] rounded-full px-4 py-2 gap-2 border border-[#D8D8D8]">
//     //           <div className="flex items-center gap-1 pr-2 border-r border-[#D8D8D8]">
//     //             <span className="text-xs font-bold text-[#212121]">
//     //               Search Type
//     //             </span>
//     //             <IconChevronDown size={14} />
//     //           </div>
//     //           <input
//     //             type="text"
//     //             placeholder="Search by..."
//     //             className="bg-transparent text-sm focus:outline-none w-40"
//     //           />
//     //           <IconSearch size={16} className="text-gray-400" />
//     //         </div>

//     //         <button className="flex items-center gap-2 px-6 py-2 border border-[#D8D8D8] rounded-full text-sm font-bold text-[#212121] hover:bg-gray-50">
//     //           <IconLayoutGrid size={18} />
//     //           Columns
//     //         </button>
//     //       </div>
//     //     </div>

//     //     <div className="overflow-auto flex-1 hide-scrollbar">
//     //       <table className="w-full text-[11px] border-collapse">
//     //         <thead className="sticky top-0 bg-white z-10 border-b border-dashed border-gray-300">
//     //           <tr className="text-left text-[#131327]/60 font-bold uppercase tracking-wider">
//     //             <th
//     //               rowSpan={2}
//     //               className="px-3 py-4 border-r border-dashed border-gray-200"
//     //             >
//     //               S/N
//     //             </th>
//     //             <th
//     //               rowSpan={2}
//     //               className="px-3 py-4 border-r border-dashed border-gray-200"
//     //             >
//     //               AWB No.
//     //             </th>
//     //             <th
//     //               rowSpan={2}
//     //               className="px-3 py-4 border-r border-dashed border-gray-200"
//     //             >
//     //               Ref.
//     //             </th>
//     //             <th
//     //               rowSpan={2}
//     //               className="px-3 py-4 border-r border-dashed border-gray-200"
//     //             >
//     //               Warehouse
//     //             </th>
//     //             <th
//     //               colSpan={4}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200"
//     //             >
//     //               Address
//     //             </th>
//     //             <th
//     //               colSpan={3}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200"
//     //             >
//     //               Receiver Details
//     //             </th>
//     //             <th
//     //               colSpan={4}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200 border-x"
//     //             >
//     //               Item Details
//     //             </th>
//     //             <th
//     //               rowSpan={2}
//     //               className="px-3 py-4 border-r border-dashed border-gray-200"
//     //             >
//     //               Track No.
//     //             </th>
//     //             <th
//     //               colSpan={2}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200"
//     //             >
//     //               Order Type
//     //             </th>
//     //             <th
//     //               colSpan={3}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200"
//     //             >
//     //               Picker Details
//     //             </th>
//     //             <th
//     //               rowSpan={2}
//     //               className="px-3 py-4 border-r border-dashed border-gray-200"
//     //             >
//     //               Client
//     //             </th>
//     //             <th
//     //               colSpan={2}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200"
//     //             >
//     //               3PL Details
//     //             </th>
//     //             <th
//     //               colSpan={2}
//     //               className="text-center px-3 py-2 border-r border-dashed border-gray-200"
//     //             >
//     //               Create Details
//     //             </th>
//     //             <th rowSpan={2} className="px-3 py-4 text-center">
//     //               Actions
//     //             </th>
//     //           </tr>
//     //           <tr className="text-left text-[#131327]/50 font-medium">
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Origin
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Country
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               City
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               District
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Name
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Mobile
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Address
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               SKU
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               QTY
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Location
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200 ">
//     //               Status
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200 font-bold">
//     //               Type
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200 font-bold">
//     //               Amount
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Picker
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Date
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Status
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Company
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               AWB
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               By
//     //             </th>
//     //             <th className="px-3 py-2 border-r border-dashed border-gray-200">
//     //               Date
//     //             </th>
//     //           </tr>
//     //         </thead>
//     //         <tbody className="divide-y divide-gray-100">
//     //           {details.map((row: PickingDetailRow, idx: number) => (
//     //             <tr key={idx} className="hover:bg-gray-50 transition-colors">
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 font-bold text-[#212121]">
//     //                 {row.sn}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-[#212121]">
//     //                 {row.awb}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-gray-500 font-mono text-[10px]">
//     //                 {row.ref}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 font-bold text-[#212121]">
//     //                 {row.warehouse}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.origin}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.country}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.city}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.district}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 font-medium">
//     //                 {row.receiverName}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.receiverMobile}
//     //               </td>
//     //               <td
//     //                 className="px-3 py-4 border-r border-dashed border-gray-100 max-w-[120px] truncate"
//     //                 title={row.receiverAddress}
//     //               >
//     //                 {row.receiverAddress}
//     //               </td>
//     //               <td
//     //                 className="p-0 border-r border-dashed border-gray-100"
//     //                 colSpan={4}
//     //               >
//     //                 <table className="w-full text-[11px]">
//     //                   <tbody>
//     //                     {row.items.map((item: any, iIdx: number) => (
//     //                       <tr
//     //                         key={iIdx}
//     //                         className={
//     //                           iIdx !== row.items.length - 1
//     //                             ? "border-b border-gray-50"
//     //                             : ""
//     //                         }
//     //                       >
//     //                         <td className="px-3 py-2 w-[80px] font-medium">
//     //                           {item.sku}
//     //                         </td>
//     //                         <td className="px-3 py-2 w-[40px] text-center font-bold text-blue-600">
//     //                           {item.qty}
//     //                         </td>
//     //                         <td className="px-3 py-2 w-[80px] text-center font-mono text-gray-500 whitespace-nowrap">
//     //                           {item.location}
//     //                         </td>
//     //                         <td className="px-3 py-2">
//     //                           <span
//     //                             className={`${item.color} text-white px-3 py-1 rounded text-[9px] font-bold block text-center whitespace-nowrap`}
//     //                           >
//     //                             {item.status}
//     //                           </span>
//     //                         </td>
//     //                       </tr>
//     //                     ))}
//     //                   </tbody>
//     //                 </table>
//     //               </td>

//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 font-mono">
//     //                 {row.trackNo}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-center">
//     //                 {row.orderType}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-center font-bold">
//     //                 {row.amount}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 font-medium">
//     //                 {row.picker}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.pickupDate}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-center">
//     //                 <span className="bg-red-500 text-white w-5 h-5 flex items-center justify-center rounded text-[10px] font-bold mx-auto">
//     //                   {row.pickupStatus}
//     //                 </span>
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 font-bold">
//     //                 {row.client}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.tplCompany}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-[10px] font-mono">
//     //                 {row.tplAwb}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100">
//     //                 {row.createdBy}
//     //               </td>
//     //               <td className="px-3 py-4 border-r border-dashed border-gray-100 text-[9px] leading-tight text-gray-500">
//     //                 {row.createdAt}
//     //               </td>
//     //               <td className="px-3 py-4 text-center">
//     //                 <button className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400">
//     //                   <IoArrowUndoCircle size={18} />
//     //                 </button>
//     //               </td>
//     //             </tr>
//     //           ))}
//     //         </tbody>
//     //       </table>
//     //     </div>
//     //   </div>
//     // </div>

//     <div className="flex flex-col h-full bg-[#F7F6F2] mb-10 rounded-3xl  ">
//       <div className="flex items-center justify-between px-6 py-4 border-b bg-white rounded-t-3xl">
//         <div className="flex items-center gap-4">
//           <button
//             onClick={onBack}
//             className="p-2 hover:bg-gray-100 rounded-full"
//           >
//             <IconArrowLeft size={22} />
//           </button>
//           <h1 className="text-2xl font-bold text-[#212121]">
//             Pick List Order View
//           </h1>
//         </div>

//         <div className="flex items-center gap-3">
//           <button className="p-3 bg-white rounded-full shadow-sm hover:shadow">
//             <IconFileText size={20} />
//           </button>
//           <button className="p-3 bg-white rounded-full shadow-sm hover:shadow">
//             <IconPrinter size={20} />
//           </button>
//           <button className="p-3 bg-white rounded-full shadow-sm hover:shadow text-red-500">
//             <IconTrash size={20} />
//           </button>
//         </div>
//       </div>
//       <div className="p-8 border-b bg-white ">
//         <div className="flex justify-between items-start">
//           <div>
//             <div className="text-sm text-gray-500">PICK LIST NUMBER</div>
//             <h2 className="text-4xl font-black tracking-tighter text-[#212121]">
//               {picklist.picklistNumber}
//             </h2>
//             <div className="flex gap-2 mt-3">
//               <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
//                 6 SKUs
//               </span>
//               <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
//                 3 Picked
//               </span>
//               <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
//                 2 Orders
//               </span>
//               <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-medium">
//                 Invoice Pending
//               </span>
//             </div>
//           </div>

//           {/* Right Side Info Cards */}
//           <div className="flex itemes-center gap-6">
//             <div className="grid grid-cols-2 gap-4 text-right">
//               <div className="bg-gray-50 rounded-2xl p-4">
//                 <div className="text-sm text-gray-500">Total quantity</div>
//                 <div className="text-3xl font-bold">15 units</div>
//               </div>
//               <div className="bg-gray-50 rounded-2xl p-4">
//                 <div className="text-sm text-gray-500">Destination</div>
//                 <div className="text-3xl font-bold">Riyadh</div>
//               </div>
//               <div className="bg-gray-50 rounded-2xl p-4">
//                 <div className="text-sm text-gray-500">Order type</div>
//                 <div className="text-2xl font-bold">CC</div>
//               </div>
//               <div className="bg-gray-50 rounded-2xl p-4">
//                 <div className="text-sm text-gray-500">Created</div>
//                 <div className="text-2xl font-bold">26 May</div>
//               </div>
//             </div>
//             <div className="border border-gray-200 rounded-2xl p-4 bg-white">
//               <div className="text-xs text-gray-500 mb-1">
//                 Master AWB Barcode
//               </div>
//               <div className="flex items-center gap-3">
//                 <div className="text-2xl font-mono tracking-widest">
//                   OBP1000000061
//                 </div>
//                 <div className="bg-green-500 text-white text-xs px-3 py-1 rounded-full">
//                   Scan Ready
//                 </div>
//               </div>
//               <img
//                 src="https://via.placeholder.com/380x80/000000/FFFFFF?text=OBP1000000061"
//                 alt="Barcode"
//                 className="mt-3"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="flex flex-1 overflow-hidden rounded-b-3xl">
//         <div className="w-96 border-l bg-white overflow-auto border-r">
//           {/* Warehouse Details */}
//           <div className="p-6 border-b">
//             <div className="font-bold text-sm mb-4">WAREHOUSE DETAILS</div>
//             <div className="space-y-4">
//               <div>
//                 <div className="text-xs text-gray-500">Warehouse</div>
//                 <div className="font-medium">Main Warehouse</div>
//               </div>
//               <div>
//                 <div className="text-xs text-gray-500">Origin</div>
//                 <div>Saudi Arabia</div>
//               </div>
//               <div>
//                 <div className="text-xs text-gray-500">City / District</div>
//                 <div>Riyadh - Al Wizarat</div>
//               </div>
//               <div>
//                 <div className="text-xs text-gray-500">Zone / Dock</div>
//                 <div>R1 - Dispatch Dock B</div>
//               </div>
//             </div>
//           </div>

//           {/* Picker Details */}
//           <div className="p-6 border-b">
//             <div className="font-bold text-sm mb-4">PICKER DETAILS</div>
//             <div className="bg-[#212121] text-white rounded-2xl p-5">
//               <div className="flex items-center gap-4">
//                 <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center text-2xl font-bold">
//                   AM
//                 </div>
//                 <div>
//                   <div className="font-bold">Ahmed Mansour</div>
//                   <div className="text-xs opacity-70">
//                     Picker ID PKR-204 • Morning Shift
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-6">
//               <div className="flex justify-between text-sm mb-2">
//                 <span>Picking progress</span>
//                 <span className="font-bold">58% complete</span>
//               </div>
//               <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
//                 <div className="h-full w-[58%] bg-gradient-to-r from-green-400 to-yellow-400"></div>
//               </div>
//             </div>
//           </div>

//           {/* Receiver Summary */}
//           <div className="p-6">
//             <div className="font-bold text-sm mb-4">RECEIVER SUMMARY</div>
//             <div className="space-y-4">
//               <div>
//                 <div className="text-xs text-gray-500">Receiver</div>
//                 <div className="font-medium">Test Iram</div>
//               </div>
//               <div>
//                 <div className="text-xs text-gray-500">Mobile</div>
//                 <div>4652736454</div>
//               </div>
//               <div>
//                 <div className="text-xs text-gray-500">Address coverage</div>
//                 <div className="text-sm">
//                   Prince Mansour / Abi Al Qasim Rd, Al Wizarat
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flex-1 overflow-auto p-6 bg-white">
//           <div className="bg-white rounded-3xl shadow-xl border border-[#D2D2D2] overflow-hidden">
//             <div className="p-8">
//               <h3 className="text-lg font-bold mb-4">ORDER LINE DETAILS</h3>
//               <h4 className="text-xl font-semibold mb-6">
//                 AWB, SKU & Storage Location Barcodes
//               </h4>

//               <div className="overflow-x-auto">
//                 <table className="w-full min-w-[1000px]">
//                   <thead>
//                     <tr className="border-b text-left text-xs uppercase tracking-wider text-gray-500">
//                       <th className="py-4 px-4 w-12">S/N</th>
//                       <th className="py-4 px-4">AWB / BARCODE</th>
//                       <th className="py-4 px-4">RECEIVER</th>
//                       <th className="py-4 px-4">ITEM, SKU & LOCATION</th>
//                       <th className="py-4 px-4 text-center">PICKER</th>
//                       <th className="py-4 px-4 text-center">STATUS</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y">
//                     {[1, 2].map((order, idx) => (
//                       <React.Fragment key={idx}>
//                         {Array.from({ length: 3 }).map((_, i) => (
//                           <tr key={i} className="hover:bg-gray-50">
//                             {i === 0 && (
//                               <td
//                                 rowSpan={3}
//                                 className="px-4 py-6 border-r font-bold text-center"
//                               >
//                                 {order}
//                               </td>
//                             )}
//                             {i === 0 && (
//                               <td rowSpan={3} className="px-4 py-6 border-r">
//                                 <div className="font-mono text-sm">
//                                   OBP100000006{idx + 1}
//                                 </div>
//                                 <div className="text-[10px] text-gray-400">
//                                   OBP100000006{idx + 1}
//                                 </div>
//                               </td>
//                             )}
//                             {i === 0 && (
//                               <td rowSpan={3} className="px-4 py-6 border-r">
//                                 Test Iram
//                                 <br />
//                                 <span className="text-xs text-gray-500">
//                                   4652736454
//                                 </span>
//                                 <br />
//                                 3512 Prince Mansour St, Riyadh
//                               </td>
//                             )}

//                             <td className="px-4 py-4">
//                               <div className="flex items-center gap-4">
//                                 <div>
//                                   <div className="font-mono text-sm">
//                                     Z.17769396947532103
//                                   </div>
//                                   <div className="text-xs text-gray-500">
//                                     3 units
//                                   </div>
//                                 </div>
//                                 <div className="font-mono text-xs bg-gray-100 px-2 py-1 rounded">
//                                   ZZZ-RRR1-RAC2-LVL4-sdf6
//                                 </div>
//                               </div>
//                             </td>

//                             <td className="px-4 py-4 text-center">
//                               Ahmed Mansour
//                             </td>

//                             <td className="px-4 py-4 text-center">
//                               <span
//                                 className={`px-4 py-1 rounded-full text-xs font-bold ${i === 2 ? "bg-blue-500 text-white" : "bg-green-500 text-white"}`}
//                               >
//                                 {i === 2 ? "Picking" : "Picked"}
//                               </span>
//                             </td>
//                           </tr>
//                         ))}
//                       </React.Fragment>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//           <div className="mt-4 grid grid-cols-4 gap-4">
//             <div className="p-4 border rounded-lg">
//               Cold check
//               <br />
//               <span className="font-bold">Not required</span>
//             </div>
//             <div className="p-4 border rounded-lg">
//               Packaging queue
//               <br />
//               <span className="font-bold">2 orders waiting</span>
//             </div>
//             <div className="p-4 border rounded-lg">
//               Invoice amount
//               <br />
//               <span className="font-bold">SAR 0</span>
//             </div>
//             <div className="p-4 border rounded-lg">
//               SLA target
//               <br />
//               <span className="font-bold">Today · 18:00</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PickingDetails;

import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  IconArrowLeft,
  IconPrinter,
  IconTrash,
  IconBuildingWarehouse,
  IconUserPlus,
  IconCheck,
} from "@tabler/icons-react";
import { 
  usePicklistByIdQuery,
  useDeletePicklistMutation,
  useUpdatePicklistStatusMutation,
} from "../../../apis/picklistApis";
import formatDate from "../../../utilities/helper";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import NoDataFound from "../../../components/common/NoDataFound";
import toast from "react-hot-toast";
import PrintModal from "./PrintModal";
import AssignStaffModal from "./AssignStaffModal";
import DeletePickingModal from "./DeletePickingModal";
import Barcode from "../../../components/common/Barcode";
import { usePermission } from "../../../hooks/usePermissionTabs";
import { useLanguage } from "../../../context/LanguageContext";

interface PickingDetailsProps {
  onBack: () => void;
  picklistId: string;
}

interface OrderItem {
  sku: string;
  qty: number;
  status: string;
  location: string;
  barcodeLabel?: string;
}

interface OrderDetail {
  awbNumber: string;
  referenceNumber: string;
  receiver: {
    name: string;
    mobile: string;
    addresses?: Array<{
      countryName: string;
      cityName: string;
      districtName: string;
      address: string;
    }>;
  };
  sender?: {
    addresses?: Array<{
      cityName: string;
    }>;
  };
  shipment?: {
    paymentType: string;
    codAmount: number;
  };
  status: string;
  oLineItems?: Array<{
    sku: string;
    quantity: number;
    status: string;
  }>;
  invoice?: string;
}

interface PicklistOrder {
  order: OrderDetail;
  orderAllocations?: Array<{
    product?: { sku: string };
    quantity: number;
    status: string;
    whBinLocation?: { barcodeLabel: string };
    whPalletLocation?: { barcodeLabel: string };
  }>;
}

interface PicklistData {
  picklistNumber: string;
  picklistOrders: PicklistOrder[];
  warehouseId: string;
  assignee?: {
    details?: { fullName: string };
    email?: string;
  };
  client?: { name: string };
  creator?: {
    details?: { fullName: string };
    email?: string;
  };
  createdAt: string;
}

const PickingDetails: React.FC<PickingDetailsProps> = ({
  onBack,
  picklistId,
}) => {
  const queryClient = useQueryClient();
  const { allowed: canUpdateOrder } = usePermission("orders", "update");
  const { allowed: canDeleteOrder } = usePermission("orders", "delete");
  const { t } = useLanguage();

  const {
    data: picklist,
    isLoading,
    isError,
  } = usePicklistByIdQuery(picklistId);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);

  const deletePicklistMutate = useDeletePicklistMutation();
  const updateStatusMutate = useUpdatePicklistStatusMutation();

  const confirmDelete = () => {
    deletePicklistMutate.mutate(picklistId, {
      onSuccess: () => {
        toast.success("Picklist deleted successfully");
        setShowDeleteModal(false);
        queryClient.invalidateQueries({ queryKey: ["picklists"] });
        onBack();
      },
      onError: (error: any) => {
        toast.error(error?.message || "Failed to delete picklist");
      },
    });
  };

  const handleMarkAsPicked = () => {
    updateStatusMutate.mutate(
      { id: picklistId, status: "PICKED" },
      {
        onSuccess: () => {
          toast.success("Picklist status updated to PICKED successfully");
          queryClient.invalidateQueries({ queryKey: ["picklist", picklistId] });
          queryClient.invalidateQueries({ queryKey: ["picklists"] });
        },
        onError: (error: any) => {
          toast.error(error?.message || "Failed to update picklist status");
        },
      }
    );
  };

  // Helper for status badge styling
  const getStatusBadge = (status: string) => {
    const statusLower = status?.toLowerCase() || "";
    if (statusLower === "picked" || statusLower === "picked_up") {
      return (
        <span className="px-3 py-1 rounded-full text-xs font-bold bg-green-500 text-white">
          {t("Picked")}
        </span>
      );
    }
    if (statusLower === "picking" || statusLower === "in_progress") {
      return (
        <span className="px-3 py-1 rounded-full text-xs font-bold bg-blue-500 text-white">
          {t("Picking")}
        </span>
      );
    }
    if (statusLower === "pending") {
      return (
        <span className="px-3 py-1 rounded-full text-xs font-bold bg-yellow-500 text-white">
          {t("Pending")}
        </span>
      );
    }
    return (
      <span className="px-3 py-1 rounded-full text-xs font-bold bg-gray-300 text-gray-700">
        {status ? t(status) : t("Unknown")}
      </span>
    );
  };

  // Calculate summary stats from dynamic data
  const calculateStats = () => {
    if (!picklist?.picklistOrders)
      return { totalSkus: 0, totalPicked: 0, totalOrders: 0, totalQuantity: 0 };

    let totalSkus = 0;
    let totalPicked = 0;
    let totalQuantity = 0;

    picklist.picklistOrders.forEach((po: PicklistOrder) => {
      const items = po.orderAllocations
        ? po.orderAllocations
        : po.order?.oLineItems || [];

      items.forEach((item: any) => {
        totalSkus++;
        totalQuantity += item.quantity || 0;
        if (
          item.status?.toLowerCase() === "picked" ||
          item.status?.toLowerCase() === "completed"
        ) {
          totalPicked++;
        }
      });
    });

    return {
      totalSkus,
      totalPicked,
      totalOrders: picklist.picklistOrders.length,
      totalQuantity,
    };
  };

  // Get unique warehouse/destination info from first order
  const getWarehouseInfo = () => {
    const firstOrder = picklist?.picklistOrders?.[0]?.order;
    const senderAddr = firstOrder?.sender?.addresses?.[0];
    const receiverAddr = firstOrder?.receiver?.addresses?.[0];

    const warehouseName =
      firstOrder?.warehouse?.name || picklist?.warehouseId || "Main Warehouse";
    const warehouseIdStr = firstOrder?.warehouse?.id || "";

    return {
      warehouse: t(warehouseName),
      origin: senderAddr?.cityName || t("Saudi Arabia"),
      cityDistrict: receiverAddr
        ? `${receiverAddr.cityName} - ${receiverAddr.districtName}`
        : t("Riyadh - Al Wizarat"),
      zoneDock:
        warehouseName !== "Main Warehouse"
          ? `${warehouseName.substring(0, 2).toUpperCase()} - Dispatch Dock ${warehouseIdStr ? warehouseIdStr.substring(0, 1).toUpperCase() : "A"}`
          : "R1 - Dispatch Dock B",
    };
  };

  const getShift = (createdAtDate?: string | Date) => {
    if (!createdAtDate) return t("Morning Shift");
    const date = new Date(createdAtDate);
    const hours = date.getHours();
    if (hours >= 6 && hours < 14) return t("Morning Shift");
    if (hours >= 14 && hours < 22) return t("Afternoon Shift");
    return t("Night Shift");
  };

  const getSlaTarget = (createdAtDate?: string | Date) => {
    if (!createdAtDate) return t("Today - 18:00");
    const created = new Date(createdAtDate);
    const slaTime = new Date(created.getTime() + 4 * 60 * 60 * 1000); // 4 hours SLA
    const now = new Date();

    const isToday = created.toDateString() === now.toDateString();
    const hoursStr = slaTime.getHours().toString().padStart(2, "0");
    const minsStr = slaTime.getMinutes().toString().padStart(2, "0");
    const timeStr = `${hoursStr}:${minsStr}`;

    if (isToday) {
      return `${t("Today")} - ${timeStr}`;
    } else {
      const options: Intl.DateTimeFormatOptions = {
        day: "numeric",
        month: "short",
      };
      return `${slaTime.toLocaleDateString("en-US", options)} - ${timeStr}`;
    }
  };

  // Get picker info
  const getPickerInfo = () => {
    const stats = calculateStats();
    const progress =
      stats.totalSkus > 0
        ? Math.round((stats.totalPicked / stats.totalSkus) * 100)
        : 0;

    return {
      name:
        picklist?.assignee?.details?.fullName ||
        picklist?.assignee?.email ||
        t("Unassigned"),
      id: picklist?.assignee?.id
        ? `PKR-${picklist.assignee.id.substring(0, 5).toUpperCase()}`
        : "PKR-204",
      shift: getShift(picklist?.createdAt),
      progress,
    };
  };


  const getGroupedOrders = () => {
    if (!picklist?.picklistOrders) return [];

    return picklist.picklistOrders.map((po: PicklistOrder, idx: number) => {
      const order = po.order;
      const receiverAddr = order?.receiver?.addresses?.[0];
      let items: OrderItem[] = [];

      if (po.orderAllocations) {
        items = po.orderAllocations.map((alloc: any) => ({
          sku: alloc.product?.sku || "",
          qty: alloc.quantity || 0,
          status: alloc.status || "",
          location:
            alloc.whBinLocation?.barcodeLabel ||
            alloc.whPalletLocation?.barcodeLabel ||
            "",
          barcodeLabel:
            alloc.whBinLocation?.barcodeLabel ||
            alloc.whPalletLocation?.barcodeLabel ||
            "",
        }));
      } else if (order?.oLineItems) {
        items = order.oLineItems.map((item: any) => ({
          sku: item.sku || "",
          qty: item.quantity || 0,
          status: item.status || "",
          location: "",
          barcodeLabel: "",
        }));
      }

      return {
        id: idx + 1,
        awb: order?.awbNumber || "",
        referenceNumber: order?.referenceNumber || "",
        receiverName: order?.receiver?.name || "",
        receiverMobile: order?.receiver?.mobile || "",
        receiverAddress:
          receiverAddr?.address?.replace(/<[^>]*>/g, "") ||
          (receiverAddr
            ? `${receiverAddr.cityName}, ${receiverAddr.districtName}`
            : ""),
        items,
        amount: order?.shipment?.codAmount
          ? `SAR ${order.shipment.codAmount}`
          : "SAR 0",
        status: order?.status || "",
        invoice: order?.invoice || "",
      };
    });
  };

  const stats = calculateStats();
  const warehouseInfo = getWarehouseInfo();
  const pickerInfo = getPickerInfo();
  const groupedOrders = getGroupedOrders();
  const createdDate = picklist?.createdAt
    ? formatDate(picklist.createdAt)
    : "N/A";
  const masterAWB = groupedOrders[0]?.awb || "N/A";

  if (isLoading) {
    return (
      <div className="p-8">
        <TableSkeleton
          columns={[
            "#",
            "AWB",
            "Receiver",
            "SKU & Location",
            "Picker",
            "Status",
          ]}
        />
      </div>
    );
  }

  if (isError || !picklist) {
    return (
      <div className="flex flex-col h-full items-center justify-center bg-[#F7F6F2]">
        <NoDataFound message={t("Failed to load picklist details")} />
        <button
          onClick={onBack}
          className="mt-4 px-6 py-2 bg-[#FCB910] rounded-full font-bold"
        >
          {t("Go Back")}
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full bg-[#F7F6F2] rounded-3xl mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-6 py-4 border-b bg-white rounded-t-3xl">
        <div className="flex items-center gap-4">
          <button
            onClick={onBack}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors animate-hover"
          >
            <IconArrowLeft size={22} />
          </button>
          <h1 className="text-xl sm:text-2xl font-bold text-[#212121] whitespace-nowrap">
            {t("Pick List Order View")}
          </h1>
        </div>
        <div className="flex items-center gap-3 flex-wrap sm:flex-nowrap justify-start sm:justify-end w-full sm:w-auto">
          {picklist?.assignee && !["PICKED", "COMPLETED", "CANCELLED"].includes(picklist.status) && canUpdateOrder && (
            <button
              onClick={handleMarkAsPicked}
              className="bg-[#20BF55] hover:bg-[#1a9e43] text-white px-4 py-2 rounded-full text-sm font-bold shadow-sm hover:shadow transition-all flex items-center gap-1.5 shrink-0"
            >
              <IconCheck size={16} /> {t("Mark as Picked")}
            </button>
          )}
          {!picklist?.assignee && canUpdateOrder && (
            <button
              onClick={() => setShowAssignModal(true)}
              className="p-3 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow"
              title={t("Assign Staff")}
            >
              <IconUserPlus size={20} />
            </button>
          )}
          <button
            onClick={() => setShowPrintModal(true)}
            className="p-3 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow"
            title={t("Print Picklist")}
          >
            <IconPrinter size={20} />
          </button>
          {canDeleteOrder && (
            <button
              onClick={() => setShowDeleteModal(true)}
              className="p-3 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow text-red-500"
              title={t("Delete Picklist")}
            >
              <IconTrash size={20} />
            </button>
          )}
        </div>
      </div>      <div className="p-6 border-b bg-white">
        <div className="flex justify-between items-start gap-6 flex-wrap md:flex-nowrap">
          {/* Left Side: Master AWB Barcode and Warehouse Details */}
          <div className="flex flex-col gap-4 flex-[3] max-w-[950px] w-full">
            <div className="w-fit border border-gray-200 rounded-2xl p-4 bg-white self-start">
              <div className="text-xs text-gray-500 mb-1">
                {t("Picklist Barcode")}
              </div>
              <div className="mt-3 h-12 bg-gray-100 rounded flex items-center justify-center w-[240px] p-1">
                {picklist.picklistNumber ? (
                  <Barcode
                    value={picklist.picklistNumber}
                    height={40}
                    width={1.8}
                    className="h-10 w-[240px]"
                  />
                ) : (
                  <div className="text-gray-400 text-xs">{t("No Barcode")}</div>
                )}
              </div>
              <h2 className="text-3xl sm:text-4xl font-black tracking-tighter text-[#212121]">
                {picklist.picklistNumber}
              </h2>
            </div>
 
            {/* Warehouse Details just below barcode - width increased, height decreased */}
            <div className="border border-gray-100 rounded-2xl p-4 bg-gray-50 w-full">
              <div className="font-bold text-xs text-gray-700 mb-3 flex items-center gap-2">
                <IconBuildingWarehouse size={14} /> {t("WAREHOUSE DETAILS")}
              </div>
              <div className="flex flex-wrap gap-x-8 gap-y-2 text-xs">
                <div className="flex items-center gap-1.5">
                  <span className="text-gray-500 font-semibold">{t("Warehouse")}:</span>
                  <span className="font-bold text-gray-800">{warehouseInfo.warehouse}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-gray-500 font-semibold">{t("Origin")}:</span>
                  <span className="font-bold text-gray-800">{warehouseInfo.origin}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-gray-500 font-semibold">{t("City/District")}:</span>
                  <span className="font-bold text-gray-800">{warehouseInfo.cityDistrict}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-gray-500 font-semibold">{t("Zone/Dock")}:</span>
                  <span className="font-bold text-gray-800">{warehouseInfo.zoneDock}</span>
                </div>
              </div>
            </div>
          </div>
 
          {/* Right Side: Picklist Number & Badges */}
          <div className="flex flex-col items-start md:items-end text-left md:text-right gap-4 flex-1 min-w-[200px] w-full md:w-auto">
            <div>
              <div className="flex gap-2 mt-0 md:mt-4 justify-start md:justify-end flex-wrap">
                <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                  {stats.totalSkus} {t("SKUs")}
                </span>
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                  {stats.totalPicked} {t("Picked")}
                </span>
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                  {stats.totalOrders} {t("Orders")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <div className="flex flex-1 overflow-hidden rounded-b-3xl">
 
        <div className="flex-1 overflow-auto bg-white p-5">
          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <div className="p-5 border-b">
              <h3 className="text-lg font-bold">{t("ORDER LINE DETAILS")}</h3>
              <p className="text-sm text-gray-500 mt-1">
                {t("AWB, SKU & Storage Location Barcodes")}
              </p>
            </div>
 
            <div className="overflow-x-auto">
              <table className="w-full min-w-[1000px]">
                <thead className="bg-gray-50">
                  <tr className="border-b text-left text-xs uppercase tracking-wider text-gray-500">
                    <th className="py-3 px-4 w-12">{t("S/N")}</th>
                    <th className="py-3 px-4">{t("AWB")}</th>
                    <th className="py-3 px-4">{t("REF")}</th>
                    <th className="py-3 px-4">{t("RECEIVER")}</th>
                    <th className="py-3 px-4">{t("SKU")}</th>
                    <th className="py-3 px-4 text-center">{t("QUANTITY")}</th>
                    <th className="py-3 px-4">{t("LOCATION")}</th>
                    <th className="py-3 px-4 text-center">{t("PICKER")}</th>
                    <th className="py-3 px-4 text-center">{t("STATUS")}</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {groupedOrders.map((order) => (
                    <React.Fragment key={order.id}>
                      {order.items.map((item, itemIdx) => (
                        <tr
                          key={itemIdx}
                          className="hover:bg-gray-50 transition-colors"
                        >
                          {itemIdx === 0 && (
                            <td
                              rowSpan={order.items.length}
                              className="px-4 py-4 border-r align-top font-bold text-center bg-gray-50/30"
                            >
                              {order.id}
                            </td>
                          )}

                          {itemIdx === 0 && (
                            <td
                              rowSpan={order.items.length}
                              className="px-4 py-4 border-r align-top"
                            >
                              <div className="font-mono text-sm font-semibold text-gray-950">
                                {order.awb || t("N/A")}
                              </div>
                              <div className="mt-3 bg-gray-100 rounded flex items-start justify-start w-fit p-1">
                                {order.awb ? (
                                  <Barcode
                                    value={order.awb}
                                    height={28}
                                    width={1.2}
                                    className="h-8 w-[140px]"
                                  />
                                ) : (
                                  <div className="text-gray-400 text-[10px]">
                                    {t("No Barcode")}
                                  </div>
                                )}
                              </div>
                            </td>
                          )}

                          {itemIdx === 0 && (
                            <td
                              rowSpan={order.items.length}
                              className="px-4 py-4 border-r align-top"
                            >
                              <div className="font-mono text-sm font-semibold text-gray-950">
                                {order.referenceNumber || t("N/A")}
                              </div>
                              <div className="mt-3 bg-gray-100 rounded flex items-start justify-start w-fit p-1">
                                {order.referenceNumber ? (
                                  <Barcode
                                    value={order.referenceNumber}
                                    height={28}
                                    width={1.2}
                                    className="h-8 w-[140px]"
                                  />
                                ) : (
                                  <div className="text-gray-400 text-[10px]">
                                    {t("No Barcode")}
                                  </div>
                                )}
                              </div>
                            </td>
                          )}

                          {itemIdx === 0 && (
                            <td
                              rowSpan={order.items.length}
                              className="px-4 py-4 border-r align-top"
                            >
                              <div className="font-medium">
                                {order.receiverName}
                              </div>
                              <div className="text-xs text-gray-500">
                                {order.receiverMobile}
                              </div>
                              <div className="text-xs text-gray-600 mt-1 break-words max-w-[180px]">
                                {order.receiverAddress}
                              </div>
                            </td>
                          )}

                          <td className="px-4 py-4">
                            <div className="flex flex-col gap-1.5">
                              <div className="font-mono text-sm font-semibold text-gray-950">
                                {item.sku || t("N/A")}
                              </div>
                              {item.sku ? (
                                <div className="p-1 bg-gray-100 rounded w-fit mt-1">
                                  <Barcode
                                    value={item.sku}
                                    height={28}
                                    width={1.2}
                                    className="h-8 w-[140px]"
                                  />
                                </div>
                              ) : (
                                <div className="text-gray-400 text-[10px] mt-1">
                                  {t("No Barcode")}
                                </div>
                              )}
                            </div>
                          </td>

                          <td className="px-4 py-4 text-center">
                            <span className="text-sm font-bold text-gray-800">
                              {item.qty} {t("units")}
                            </span>
                          </td>

                          <td className="px-4 py-4">
                            {item.location ? (
                              <div className="flex flex-col gap-2">
                                <div className="font-mono text-xs bg-gray-100 px-2 py-1 rounded-md text-gray-700 w-fit font-medium">
                                  {item.location}
                                </div>
                                <div className="p-1 bg-gray-100 rounded w-fit">
                                  <Barcode
                                    value={item.location}
                                    height={40}
                                    width={1.2}
                                    className="h-12 w-[140px]"
                                  />
                                </div>
                              </div>
                            ) : (
                              <span className="text-gray-400 text-xs font-medium">{t("N/A")}</span>
                            )}
                          </td>

                          <td className="px-4 py-4 text-center">
                            <div className="flex flex-col items-center">
                              <div className="font-medium text-sm">
                                {t(pickerInfo.name)}
                              </div>
                              <div className="text-xs text-gray-400">
                                {t("Picker")}
                              </div>
                            </div>
                          </td>

                          <td className="px-4 py-4 text-center">
                            <div className="space-y-1">
                              {getStatusBadge(item.status)}
                              <div className="text-xs text-gray-400">
                                {createdDate}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>


        </div>
      </div>

      {/* Modals */}
      <DeletePickingModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        pickupId={picklistId}
      />

      <PrintModal
        isOpen={showPrintModal}
        onClose={() => setShowPrintModal(false)}
        picklistId={picklistId}
      />

      <AssignStaffModal
        isOpen={showAssignModal}
        onClose={() => setShowAssignModal(false)}
        picklistId={picklistId}
        currentAssignedId={picklist.assignedTo || null}
      />
    </div>
  );
};

export default PickingDetails;
